import { useFormik } from 'formik'
import { MapNameForm as View } from 'ui-components'
import * as Yup from 'yup'
import { useMap } from '~map-preview/states/map'

import { useUpdateMapName } from '~map-settings/query/useUpdateMapName'

export const MapName = () => {
  const map = useMap()
  const updateMapName = useUpdateMapName()
  const form = useFormik({
    initialValues: {
      name: map?.name || ''
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required('Name is required')
    }),
    onSubmit: async () => {}
  })

  const handleUpdateMapName = async (name: string) => {
    if (name === map.name) return
    await updateMapName(name)
  }

  return (
    <View
      handleUpdateMapName={handleUpdateMapName}
      form={form}
    />
  )
}
